import React from "react";
import { Button } from "@mui/material";

const DialogCancelButton = ({ label = "Cancelar", onClick }) => {
    return <Button variant="outlined" color="primary" onClick={onClick} size="small">{label}</Button>
}

export default DialogCancelButton;
